import * as Sentry from '@sentry/react';
import { type FC, type ReactNode } from 'react';

const Fallback: FC = () => (
  <div style={{ padding: 16 }}>Произошла ошибка. Пожалуйста, перезагрузите страницу.</div>
);

export const AppErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: ReactNode }) => <>{children}</>,
  { fallback: <Fallback /> }
);
